import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useLeftBar } from "../../context/LeftBar";
import NavItem from "./MenuItem/NavItem";
import WebIcon from "@mui/icons-material/Web";
import { ReactComponent as ExcellenceLogo } from "../../assets/icons/excellence-logo.svg";
import { ReactComponent as LandscapeIcon } from "../../assets/icons/landscape-icon.svg";
import { ReactComponent as MedalsIcon } from "../../assets/icons/medals-icon.svg";
import { ReactComponent as StarsIcon } from "../../assets/icons/stars-icon.svg";
import { ReactComponent as IconSimulador } from "../../assets/icons/icon-simulador.svg";
import cotyLogo from "../../assets/img/new-logo-coty-white.png";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { Box, Grid, Tooltip } from "@mui/material";

import styles from "../LeftSideMenu/styles.css";
function LeftSideMenu({ app, config, logo }) {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [dataAtualizacao, setDataAtualizacao] = useState("");
  const [showSimulador, setShowSimulador] = useState();

  const validateShowSimulador = useCallback(
    async (objectId) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;

          setShowSimulador(value);
        });
      }
    },
    [app]
  );

  async function initialSelecao() {
    await app.variable.getContent("vAtualizacao", (reply) => {
      const data = reply.qContent.qString;
      setDataAtualizacao(data.substring(0, 10));
    });
  }

  useEffect(() => {
    if (app) {
      validateShowSimulador("bczGzMC");
    }
    initialSelecao();
    window.addEventListener("resize", () => setScreenWidth(window.innerWidth));

    return () => {
      window.removeEventListener("resize", () =>
        setScreenWidth(window.innerWidth)
      );
    };
  }, []);

  const { leftBarOpened, setLeftBarOpened } = useLeftBar();
  return (
    <div className={leftBarOpened ? "leftSideMenu is-opened" : "leftSideMenu"}>
      <div className="leftSideHeader">
        <div className={leftBarOpened ? "logo" : "logo is-hidden"}>
          <ExcellenceLogo />
        </div>
        <button
          type="button"
          onClick={() => {
            setLeftBarOpened(!leftBarOpened);
          }}
          className={leftBarOpened ? "" : "align-left"}
        >
          <i
            className={
              leftBarOpened
                ? "fal fa-arrow-left close-desktop"
                : "fal fa-arrow-right"
            }
          />
          <i className={leftBarOpened ? "fal fa-times close-mobile" : ""} />
        </button>
      </div>
      <div className="leftSideClientContainer">
        {leftBarOpened && (
          <>
            <div className="title">Cliente:</div>
            <div className="client-name">Coty</div>
          </>
        )}
      </div>
      <div className="leftSideContent">
        <ul>
          <NavItem muiIcon={<WebIcon />} name="Overview" path="/overview" />
        </ul>
        <ul>
          <NavItem
            muiIcon={<LandscapeIcon />}
            name="Área de Atuação"
            path={"/area/sell-out"}
            subpages={[
              {
                id: 1,
                url: "/area/sell-out",
                name: "Sell out",
              },
              {
                id: 2,
                url: "/area/positivacao",
                name: "Positivação",
              },
            ]}
          />
        </ul>
        <ul>
          <NavItem
            muiIcon={<MedalsIcon />}
            name="Golden Stores"
            path="/golden-stores/sell-out"
            subpages={[
              {
                id: 1,
                url: "/golden-stores/sell-out",
                name: "Sell out",
              },
              {
                id: 2,
                url: "/golden-stores/distribuicao",
                name: "Distribuição",
              },
            ]}
          />
        </ul>
        <ul>
          <NavItem
            muiIcon={<StarsIcon />}
            name="Pontuação Extra"
            path="/extra-scores"
          />
        </ul>

        {showSimulador === "1" && (
          <ul>
            <NavItem
              muiIcon={<IconSimulador />}
              name="Simulador"
              path="/simulador"
            />
          </ul>
        )}

        {leftBarOpened && (
          <Grid
            flexDirection={"row"}
            justifyContent={"flex-start"}
            alignItems={"center"}
            columnGap={1}
            style={{
              display: "flex",
              fontWeight: "300",
              opacity: "0.5",
              width: "100%",
              paddingLeft: "10px",
              color: "white",
              marginTop: "20px",
              fontSize: "13px",
            }}
          >
            <Grid item>
              <Tooltip
                arrow
                title={"Atualizado em"}
                enterTouchDelay={0}
                leaveTouchDelay={2000}
              >
                <AccessTimeIcon />
              </Tooltip>
            </Grid>
            <Grid item>
              <Tooltip
                arrow
                title={"Atualizado em"}
                enterTouchDelay={0}
                leaveTouchDelay={2000}
              >
                <span>{dataAtualizacao} </span>
              </Tooltip>
            </Grid>
          </Grid>
        )}
      </div>
      {leftBarOpened && (
        <Grid
          container
          flexDirection={"column"}
          justifyContent={"flex-end"}
          alignItems={"center"}
          sx={{
            height: "100%",
          }}
        >
          <Box
            component={"img"}
            src={cotyLogo}
            className="container-img-leftSide"
          />
        </Grid>
      )}
    </div>
  );
}

LeftSideMenu.defaultProps = {
  app: null,
  config: null,
  logo: null,
};

LeftSideMenu.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
  logo: PropTypes.object,
};

export default LeftSideMenu;
